import { teacherServiceURL } from '../endpoint';

export function baseSubscriptionURL() {
  const url = new URL(teacherServiceURL);
  url.pathname += 'subscriptions';
  return url;
}
